import { render } from "./Error.vue?vue&type=template&id=77fb83eb&scoped=true&ts=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=77fb83eb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/RECA/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fb83eb"]])

export default __exports__